<div>
	<gb-ui-page-heading [titleText]="pageTitle" bannerType="success">
		<ng-template #subContent>
			<div class="sub-content">
				<p>{{ 'CONFIRMATION.REFERENCE_TEXT' | translate }}</p>
				<p class="h1">
					{{ bookingNumber }}
				</p>
			</div>
		</ng-template>
	</gb-ui-page-heading>
	<div class="govuk-width-container">
		<div class="govuk-grid-row m-0">
			<h2 *ngIf="datastoreService.pageContent.confirmation_page_subtitle" id="main-content" tabindex="-1">
				{{ datastoreService.pageContent.confirmation_page_subtitle }}
			</h2>
			<p [innerHTML]="
					datastoreService.pageContent.confirmation_page_subtitle_body
				"></p>

			@if (agentMode) {
			<button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
				(click)="datastoreService?.agentRestart()">
				Agent Restart
			</button>
			}

			<ng-template #locationAddress>
				<p>
					@if (selectedLocation.address.address1) {
					{{ selectedLocation.address.address1 }}<br />
					} @if (selectedLocation.address.address2) {
					{{ selectedLocation.address.address2 }}<br />
					} @if (selectedLocation.address.address3) {
					{{ selectedLocation.address.address3 }}<br />
					} @if (selectedLocation.address.address4) {
					{{ selectedLocation.address.address4 }}<br />
					} @if (selectedLocation.address.postcode) {
					{{ selectedLocation.address.postcode }}<br />
					} @if (selectedLocation.address.country) {
					{{ selectedLocation.address.country }} }
				</p>
			</ng-template>

			<div class="govuk-grid-row">
				<div class="govuk-grid-column-full">
					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.BOOKING' | translate }}
							</h2>
						</div>

						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.SERVICE' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedService?.name }}
									</dd>
								</div>
								<div class="govuk-summary-list__row" *ngIf="selectedResourceObj?.name">
									<dt class="govuk-summary-list__key">Venue</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedResourceObj?.name }}
									</dd>
								</div>
							</dl>
						</div>
					</div>

					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.DATE_TIME' | translate }}
							</h2>
						</div>
						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.DATE' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{
										selectedSlot?.start
										| date
										: 'EEEE d MMMM yyyy'
										: ''
										: translateService.currentLang
										}}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.TIME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.displayTime }}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.DURATION' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ booking.duration }} minutes
									</dd>
								</div>
							</dl>
						</div>
					</div>

					<div class="govuk-summary-card">
						<div class="govuk-summary-card__title-wrapper">
							<h2 class="govuk-summary-card__title">
								{{ 'COMMON.PATIENT_DETAILS' | translate }}
							</h2>
						</div>
						<div class="govuk-summary-card__content">
							<dl class="govuk-summary-list">
								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.NAME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ client?.first_name }} {{ client?.last_name }}
									</dd>
								</div>

								<div class="govuk-summary-list__row">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.EMAIL_ADDRESS' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ datastoreService?.booking?.email }}
									</dd>
								</div>

								<div class="govuk-summary-list__row" *ngIf="client?.mobile_number">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.MOBILE_NUMBER' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.mobile_number }}
									</dd>
								</div>

								<div class="govuk-summary-list__row" *ngIf="client?.postcode">
									<dt class="govuk-summary-list__key">
										{{ 'COMMON.POSTNAME' | translate }}
									</dt>
									<dd class="govuk-summary-list__value">
										{{ selectedSlot?.postcode }}
									</dd>
								</div>
							</dl>
						</div>
					</div>
				</div>
			</div>

			<div class="govuk-grid-row pb-4">
				<div class="govuk-grid-column-full">
					<ng-container *ngIf="!isAdminJourney">
						<button type="submit" class="btn btn-primary" (click)="restartJourney()">
							{{ 'CONFIRMATION.RETURN_HOME' | translate }}
						</button>
					</ng-container>
					<ng-container *ngIf="isAdminJourney">
						<p class="govuk-body">
							For agents, please refresh the browser tab to return to the start.
							<br />
							For registration team, please close the browser tab and return to
							the back-office.
						</p>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>
